"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var React = tslib_1.__importStar(require("react"));
var react_dom_1 = require("react-dom");
var useBoolean_1 = tslib_1.__importDefault(require("@eduzz/houston-hooks/useBoolean"));
var Popover_1 = tslib_1.__importDefault(require("../Popover"));
var usePopover_1 = tslib_1.__importDefault(require("../Popover/usePopover"));
var TooltipBody_1 = tslib_1.__importDefault(require("./TooltipBody"));
var Tooltip = function (_a) {
    var children = _a.children, title = _a.title, _b = _a.placement, placement = _b === void 0 ? 'top' : _b, idProp = _a.id, disabled = _a.disabled, onOpen = _a.onOpen, onClose = _a.onClose;
    var _c = (0, usePopover_1.default)(), openPopover = _c.openPopover, closePopover = _c.closePopover, popoverTargetProps = _c.popoverTargetProps, popoverProps = _c.popoverProps;
    var _d = tslib_1.__read((0, useBoolean_1.default)(), 4), isPopoverCreated = _d[0], createPopover = _d[2], deletePopover = _d[3];
    var _e = tslib_1.__read(React.useState(idProp !== null && idProp !== void 0 ? idProp : "".concat(Math.floor(Math.random() * 1000))), 1), id = _e[0];
    var onOpenPopover = React.useCallback(function () {
        (0, react_dom_1.flushSync)(function () {
            createPopover();
        });
        openPopover();
        onOpen && onOpen();
    }, [onOpen, openPopover, createPopover]);
    var onClosePopover = React.useCallback(function () {
        onClose && onClose();
        closePopover();
        deletePopover();
    }, [onClose, closePopover, deletePopover]);
    var props = {
        tabIndex: 0,
        onMouseEnter: onOpenPopover,
        onMouseLeave: onClosePopover,
        ref: popoverTargetProps.ref
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [typeof children === 'string' ? ((0, jsx_runtime_1.jsx)("span", tslib_1.__assign({}, props, { children: children }))) : (React.cloneElement(children, props)), !disabled && isPopoverCreated && ((0, jsx_runtime_1.jsx)(Popover_1.default, tslib_1.__assign({ id: id }, popoverProps, { placement: placement, variant: 'tooltip' }, { children: (0, jsx_runtime_1.jsx)(TooltipBody_1.default, { title: title }) })))] }));
};
/**
 * @deprecated Use Tooltip from Antd
 * https://ant.design/components/tooltip/
 */
exports.default = React.memo(Tooltip);
